import { Gems, type GemType } from './types';

export function normalizeGemType(
  colour: unknown,
  fallback: GemType = 'red',
): GemType {
  if (typeof colour !== 'string' || colour === '') {
    return fallback;
  }

  const lower = colour.toLowerCase();
  if (lower === 'standard' || lower === 'ruby') {
    return 'red';
  }

  if (lower in Gems) {
    return lower as GemType;
  }

  return fallback;
}
